import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Textarea } from 'src/@/components/ui/textarea';
import EmojiPicker from 'src/components/EmojiPicker';

// ----------------------------------------------------------------------
// Barra de legenda com emoji, estilo WhatsApp Web.

export default function MediaCaptionBar({ value, onChange, onSubmit, disabled }) {
    const { t } = useTranslation('chat');
    const textareaRef = useRef(null);

    useEffect(() => {
        const node = textareaRef.current;
        if (!node) return;
        node.style.height = 'auto';
        node.style.height = `${Math.min(node.scrollHeight, 96)}px`;
    }, [value]);

    return (
        <div className="mx-auto w-full max-w-2xl flex items-end gap-1 rounded-xl bg-slate-100 dark:bg-slate-800 border border-gray-200 dark:border-slate-700 px-2 py-1">
            <EmojiPicker disabled={disabled} value={value} setValue={onChange} />
            <Textarea
                ref={textareaRef}
                rows={1}
                value={value}
                disabled={disabled}
                placeholder={t('mediaEditor.captionPlaceholder')}
                className="flex-1 min-h-0 resize-none border-0 bg-transparent shadow-none focus-visible:ring-0 text-sm py-2"
                onChange={(event) => onChange(event.target.value)}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' && !event.shiftKey) {
                        event.preventDefault();
                        onSubmit();
                    }
                }}
            />
        </div>
    );
}
